module.exports = __webpack_public_path__ + "static/media/product-UTStamp.3c866cba.png";